
export interface FosterFormData {
  spouseName?: string;
  applicantEmail?: string;
  phone?: string;
  address?: string;
  addressObj?: unknown; // 添加地址对象字段
}

export interface FosterFormModelsState {
  formData: FosterFormData;
}

const initialState: FosterFormModelsState = {
  formData: {},
};

export default {
  namespace: 'fosterFormModels',
  state: initialState,
  reducers: {
    updateFormData(state: FosterFormModelsState, { payload }: { payload: Partial<FosterFormData> }) {
      return {
        ...state,
        formData: {
          ...state.formData,
          ...payload,
        },
      };
    },
    reset() {
      return initialState;
    },
  },
};

export class NurseryFormModelsState {
}
